import React, { useContext, useEffect, useRef } from "react";
import JobFilter from "../../../layouts/Home/JobFilter";
import JobCard from "../../../layouts/Home/JobCard";
import CommonContext from "../../../hooks/CommonContext";
import HomePagination from "./HomePagination";
import Sorting from "../../../layouts/Home/Sorting";
import Image from "../../../utils/images";
import { useDispatch } from "react-redux";
import { handleReset } from "Actions/commonAction/milleSearchFilterActions";
import { formatNumber } from "ReusableFunctions/convertShowingResults";
import JobCardGlow from "./JobCardGlow";
import Cookie from "js-cookie";
import { decryptData } from "Security/Crypto/Crypto";

const HomeAll = ({ }) => {
  const dispatch = useDispatch()
  const containerRef = useRef(null);

  const {
    setRecommendedStatus,
    setSelectedCardPath,
    getHomeAll,
    setSelectedCardIndex,
    cardArrayDuplicateSearch,
    setCardArrayDuplicateSearch,
    setapplyFilterResponse,
    applyFilterResponse,
    refreshAction,
    setCardArray,
    setFilterArray,
    setSelectedCardData,
    gettingResponse,
    setGettingResponse,
    currentPage,
    paginationTotalCount,
    setpaginationTotalCount,
    setCardArrayDuplicate,
    setCurrentPage,
    sortBy, setSortBy,
    paginationpageCount,
    setRecommendationBelowSixtyPercentage,
    setIsApplyFilterClicked,

    // sort by 
    filter, setFilter,
    setSortByForPagination,
    setIsSharedJob, setIsSelectedJob,
    handleSelectedCardData

  } = useContext(CommonContext);

  useEffect(() => {
    if (refreshAction === false) {
      setRecommendationBelowSixtyPercentage(false)
      setGettingResponse(false);
      setapplyFilterResponse(false);
      setCardArray([]);
      setCardArrayDuplicate([]);
      setCardArrayDuplicateSearch([]);
      setSelectedCardData([]);
      setFilterArray({});
      setSelectedCardIndex(0);
      setSelectedCardPath(window.location.pathname);
      setCurrentPage(0);
      setIsApplyFilterClicked(false)
      dispatch(handleReset())
    }

    setRecommendedStatus({
      recommended_by: "",
      sc_recommended_notes: ""
    });
    setSortByForPagination("")
    setpaginationTotalCount(0)
    setSortBy("Default")
    setIsSharedJob(false)
    setIsSelectedJob(false)

    getHomeAll();
  }, []);


  useEffect(() => {
    var getLocalStorageId = Cookie.get("job_id") ? decryptData(Cookie.get("job_id")) : '';
    if (isFinite(getLocalStorageId) && getLocalStorageId && gettingResponse && cardArrayDuplicateSearch.length) {
      handleSelectedCardData(getLocalStorageId, undefined, true);
    }
  }, [Cookie.get("job_id")])


  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [cardArrayDuplicateSearch])

  return (
    <>
      <div className="col-lg-4 d-none d-xxl-block h-100 overflow-scroll" >
        <div className="card w-100 border-0 rounded-4">
          <div className="card-body">
            <JobFilter />
          </div>
        </div>
      </div>

      <div ref={containerRef} className="col-12 col-xxl-8 h-100 overflow-scroll ps-2 scroll_smooth" id="professinalHomeAllScroll">
        <div className="d-flex flex-wrap justify-content-between p-2 align-items-center">
          <div className="col-12 col-sm-6" >
            {gettingResponse === false ?
              <label className=" w-100">
                <span className="placeholder w-75 rounded py-2 pt-3"></span>
              </label>
              :
              <p className='showing-results text-secondary mb-0 py-2'>
                {
                  cardArrayDuplicateSearch.length > 0 ?
                    paginationTotalCount > 10 ?
                      `Showing : ${(currentPage * 10) + 1}-${(currentPage * 10) + cardArrayDuplicateSearch.length} of ${formatNumber(paginationTotalCount)} Jobs`
                      :
                      `Showing : 1-${cardArrayDuplicateSearch.length} of ${cardArrayDuplicateSearch.length} Jobs`
                    :
                    `Showing : 0 Jobs`
                }

              </p>
            }
          </div>
          <Sorting
            sortBy={sortBy}
            setSortBy={setSortBy}
            filter={filter}
            setFilter={setFilter}
          />
        </div>

        {/* job card skeleton  */}
        {gettingResponse === false || applyFilterResponse ?
          <JobCardGlow />
          :
          cardArrayDuplicateSearch.length > 0
            ? cardArrayDuplicateSearch.map((value, index) => {
              return (
                <div className="card w-100 mt-2 rounded-4 border-0" key={index}>
                  <div className="card-body" id={`professionalAllJob${index}Card`}>
                    <JobCard
                      cardHeading={value.job_title}
                      cardPostedOn={value.created_at}
                      cardWorkplace={value.workplace_type}
                      cardState={value.country}
                      cardSchedule={value.work_schedule}
                      cardJobType={value.job_type}
                      cardPayment={value.is_paid === "Y" ? "Paid" : "Volunteer"}
                      cardDes={value.job_overview}
                      cardId={value.id}
                      applicationStatus={value?.invited_by_employer}
                      cardType={"all"}
                      cardImage={value.profile_image}
                      companyName={value.company_name}
                    />
                  </div>
                </div>
              );
            })
            : null}

        {gettingResponse && cardArrayDuplicateSearch.length === 0 ? (
          <div className="d-flex flex-wrap align-items-center justify-content-center noRecordsFound-image-height">
            <div className="text-center">
              <img src={Image.noRecordsFound} className="w-50 h-50" alt="no data found" />
            </div>
          </div>
        ) : null}

        {
          gettingResponse === false || applyFilterResponse ?
            null
            :
            paginationpageCount > 1 ?
              <div className="w-100 pt-3">
                <HomePagination />
              </div>
              :
              null
        }
      </div>
    </>
  );
};

export default HomeAll;